import { useMutation, useQueryClient } from '@tanstack/react-query';
import ApiConfig from 'src/config/api-config';
import { sessionStore } from 'src/store/sessionStore';
import {
  useProgramGeneratorProgressStore,
  ProgressItem,
} from 'src/store/programGeneratorProgressStore';

export interface SaveProgramProgressPayload {
  program_id: string | null;
  client_id: string | null;
  step_id: string;
  data: ProgressItem[];
}

export interface SaveProgramProgressResponse {
  status: string;
  program_id: string;
  message: string;
}

const saveProgramProgress = async (
  payload: SaveProgramProgressPayload,
  uid: string,
): Promise<SaveProgramProgressResponse> => {
  const apiUrl = `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_SAVE_PROGRAM_PROGRESS}`;

  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...payload, uid }),
  });

  if (!response.ok) {
    throw new Error('Failed to save program progress');
  }

  return response.json();
};

export const useSaveProgramProgress = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: SaveProgramProgressPayload) => {
      const currentUser = sessionStore.getState().currentUser;
      const uid = currentUser?.uid;

      if (!uid) {
        throw new Error('User not authenticated');
      }
      return saveProgramProgress(payload, uid);
    },
    onSuccess: (data) => {
      if (data.program_id) {
        useProgramGeneratorProgressStore.getState().setProgramId(data.program_id);
      }
      queryClient.invalidateQueries({ queryKey: ['trainer-program-plan-list'] });
      queryClient.invalidateQueries({ queryKey: ['clientWorkoutsTab'] });
      queryClient.invalidateQueries({ queryKey: ['clientProgramTab'] });
      queryClient.invalidateQueries({ queryKey: ['clientOverview'] });
    },
  });
};
